import React from 'react';
import Mask from 'utils/src/mask';

import { Col, Row } from "components/Grid";
import { Content, Text, Label1 } from './styles';

//import Text from 'components/Text';

export default function BrokingSummary({ data }) {

    const { idOperation,
        marketingBranches,
        proponent,
        sufferedComplaintsFiveYears,
        annualBilling,
        cpfOrCnpj,
        susep,
        effectiveDate,
        possibleComplaints,
        retroactivity,
        transportBilling,
        email
    } = data;

    return (
        <Content>
            <Row>
                <Col>
                    <Label1>COTACAO Nº</Label1>
                    <Text>{idOperation}</Text>

                    <Label1>CPF/CNPJ PROPONENTE</Label1>
                    <Text>{Mask.cnpj(cpfOrCnpj)}</Text>

                    <Label1>FATURAMENTO TRANSPORTE 	&gt; 50%</Label1>
                    <Text>{transportBilling}</Text>

                    <Label1>DATA INICIO DE VIGÊNCIA</Label1>
                    <Text>{effectiveDate}</Text>
                </Col>
                <Col>
                    <Label1>PROPONENTE</Label1>
                    <Text>{proponent}</Text>

                    <Label1>SUSEP</Label1>
                    <Text>{susep}</Text>

                    <Label1>RECLAMAÇÕES SOFRIDAS - 5 ANOS</Label1>
                    <Text>{sufferedComplaintsFiveYears}</Text>

                    <Label1>RETROATIVADE</Label1>
                    <Text>{retroactivity}</Text>
                </Col>
                <Col>
                    <Label1>E-MAIL</Label1>
                    <Text>{email}</Text>

                    <Label1>FATURAMENTO ANUAL</Label1>
                    <Text>{annualBilling}
                    </Text>

                    <Label1>CONHECIMENTO DE RECLAMAÇÕES POSSIVEIS</Label1>
                    <Text>{possibleComplaints}</Text>
                </Col>
            </Row>
            <Row>
                <Col md={12} sm={12}>
                    <Label1>RAMOS DE COMERCIALIZAÇÃO</Label1>
                    {marketingBranches && marketingBranches.map((item, index) =>
                        index === marketingBranches.length - 1 && marketingBranches.length > 1
                            ?
                            <Text>
                                {`e ${item}`}
                            </Text>
                            : marketingBranches.length > 1
                                ?
                                <Text>
                                    {item + ", "}
                                </Text>
                                :
                                <Text>
                                    {item}
                                </Text>
                    )}
                </Col>
            </Row>
        </Content>
    )
}